import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from 'src/app/components/auth/service/auth.service';
import { SharedDataService } from '../shared-service/shared-data.service';
import { catchError, map, of } from 'rxjs';
import { SocketService } from '../socket-service/socket-service.service';

export const PublicGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const sharedDataService = inject(SharedDataService);
  const socket = inject(SocketService);
  
  const cleanup = () => {
    sharedDataService.saveUser(null);
    socket.disconnectSocket();
    authService.removeToken('access_token');
    authService.removeToken('refresh_token');
  };

  if (!localStorage.getItem('access_token')) {
    sharedDataService.saveUser(null);
    return of(true);
  }

  return authService.me()
    .pipe(
      map((data: any) => {
        return true;
      }),
      catchError((error) => {
        cleanup();
        return of(true);
      })
    );
};
